import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { Menu } from '@headlessui/react'
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/solid'
import IconPicker from '../UI/IconPicker'
import RenderHome from './RenderHome'
import Loader from '../UI/Loader'
import EmptyFolder from '../UI/EmptyFolder'
import tools from '../../tools'

// Écran unique « Contenu de mon app » (refonte /contenu — voir PLANNING-CONTENU-UNIFIE.md)
// Ce que le client voit ici = ce que ses vacanciers voient sur la home, dans le même ordre.
class Contenu extends Component {
	constructor(props) {
		super(props)
		this.state = {
			modules: null,
			groups: null,
			categories: null,
			lists: null,
			icons: null,
			theme: null,
			error: null,
			success: null,
			add_open: false,
			add_type: null,
			add_name: '',
			add_icon: null,
			add_prev: null,
			add_category: '',
			add_subtitle: '',
			add_hidden: false,
			add_error: null,
			add_submitting: false,
			success_path: null,
			confirm: null,
			confirm_busy: false
		}
		this.props.updateNavbarTitle('Contenu de mon app')
		this.name_length_max = 40
		//rubrique technique portant les listes créées directement sur la home (jamais affichée — la webapp n'énumère pas les rubriques, vérifié)
		this.tech_group_name = 'Contenus directs (technique)'
		this.tech_group_prefix = 'contenus-directs-technique'
	}

	componentDidMount() {
		this.loadContent()
	}

	componentDidUpdate(prevProps) {
		if (prevProps.modules !== this.props.modules)
			this.loadContent(true)
	}

	loadContent = (fromProps = false) => {
		if (fromProps === true && this.props.modules && this.state.groups !== null)
		{
			let modules = tools.clone(this.props.modules)
			modules.sort((a, b) => {
				return a.order - b.order
			})
			this.setState({ modules: modules })
		}
		else
		{
			Promise.all([
				this.props.fetchModules(),
				this.props.fetchGroups(),
				this.props.fetchCategories(),
				this.props.fetchLists(true),
				this.props.fetchIcons(),
				this.props.fetchTheme()
			])
			.then(([modules, groups, categories, lists, icons, theme]) => {
				modules = tools.clone(modules)
				modules.sort((a, b) => {
					return a.order - b.order
				})
				this.setState({ modules: modules, groups: groups, categories: categories, lists: lists, icons: icons, theme: theme })
			})
			.catch(err => {
				this.setState({ error: tools.default_error_msg("Impossible de récupérer le contenu", 1) })
				console.log(err)
			})
		}
	}

	// Monte ou descend un module d'une position (direction -1 ou +1)
	moveModule = (index, direction) => {
		const target = index + direction
		if (target < 0 || target >= this.state.modules.length)
			return ;
		let modules = tools.clone(this.state.modules)
		const order_tmp = modules[index].order
		modules[index].order = modules[target].order
		modules[target].order = order_tmp
		const tmp = modules[index]
		modules[index] = modules[target]
		modules[target] = tmp
		this.setState({ modules: modules, error: null })
		this.props.updateModulesOrder(modules)
		.then(ret => {
			if (!ret)
				this.setState({ error: tools.default_error_msg("Impossible de réordonner les modules", 2) })
		})
		.catch(err => {
			this.setState({ error: tools.default_error_msg("Impossible de réordonner les modules", 3) })
			console.log(err)
		})
	}

	// Masque ou affiche un module sur l'app (champ hidden, lot C)
	toggleHidden = (module) => {
		this.props.updateModuleHidden(module._id, !(module.hidden === true))
		.then(ret => {
			if (!ret)
				this.setState({ error: tools.default_error_msg("Impossible de changer la visibilité", 1) })
			else
				this.setState({ error: null })
		})
		.catch(err => {
			this.setState({ error: tools.default_error_msg("Impossible de changer la visibilité", 2) })
			console.log(err)
		})
	}

	// ---- Parcours « Ajouter à l'accueil » (maquette v7, section 04) ----

	openAdd = () => {
		this.setState({ add_open: true, add_type: null, add_name: '', add_icon: null, add_prev: null, add_category: '', add_subtitle: '', add_hidden: false, add_error: null, add_submitting: false })
	}

	closeAdd = () => {
		if (this.state.add_submitting === true)
			return ;
		this.setState({ add_open: false })
	}

	chooseAddType = (type) => {
		this.setState({ add_type: type, add_error: null })
	}

	handleAddName = (event) => {
		const value = event.target.value
		this.setState({ add_name: value })
	}

	handleAddIcon = (icon) => {
		const prev = tools.getIconPreview(this.state.icons, icon, 'lineal', 'blank')
		this.setState({ add_icon: icon, add_prev: prev })
	}

	handleAddCategory = (event) => {
		const value = event.target.value
		this.setState({ add_category: value })
	}

	handleAddSubtitle = (event) => {
		const value = event.target.value
		this.setState({ add_subtitle: value })
	}

	// Retrouve (ou crée au premier besoin) la rubrique technique des listes directes
	_ensureTechnicalGroup = () => {
		for (let i = 0; i < this.state.groups.length; i++)
		{
			const translations = this.state.groups[i].translations
			for (let j = 0; j < (translations || []).length; j++)
			{
				if (translations[j].prefix === this.tech_group_prefix)
					return Promise.resolve(this.state.groups[i])
			}
		}
		if (!this.state.icons || !this.state.icons.length)
			return Promise.reject('no_icon')
		return this.props.insertGroup({
			translations: [{ lang: this.props.lang_default, name: this.tech_group_name }],
			icon: this.state.icons[0]._id
		})
	}

	// Catégories pas encore mises en avant sur l'accueil (candidates au picker)
	_availableCategories = () => {
		let available = []
		for (let i = 0; i < this.state.categories.length; i++)
		{
			const category = this.state.categories[i]
			let featured = false
			for (let j = 0; j < this.state.modules.length; j++)
			{
				const module = this.state.modules[j]
				if (module.type === "page" && module.values && module.values.category === category._id)
					featured = true
				else if (module.type === "list" && module.values && this.state.lists)
				{
					for (let k = 0; k < this.state.lists.length; k++)
					{
						if (this.state.lists[k]._id === module.values.list && this.state.lists[k].category === category._id)
							featured = true
					}
				}
				if (featured)
					break
			}
			if (!featured)
				available.push(category)
		}
		return available
	}

	submitAdd = (event) => {
		event.preventDefault()
		if (this.state.add_submitting === true)
			return ;
		if (this.state.add_type === "existing")
		{
			let category = null
			for (let i = 0; i < this.state.categories.length; i++)
			{
				if (this.state.categories[i]._id === this.state.add_category)
				{
					category = this.state.categories[i]
					break
				}
			}
			if (!category)
			{
				this.setState({ add_error: "Sélectionnez une catégorie" })
				return ;
			}
			const cat_name = tools.getTranslationValue(category.translations, this.props.lang_default, 'name')
			const subtitle = this.state.add_subtitle.trim()
			let type = 'page'
			let values = { category: category._id, page: '' }
			if (category.type === "list")
			{
				let list = null
				for (let i = 0; i < this.state.lists.length; i++)
				{
					if (this.state.lists[i].category === category._id)
					{
						list = this.state.lists[i]
						break
					}
				}
				if (!list)
				{
					this.setState({ add_error: tools.default_error_msg("La liste de cette catégorie est introuvable", 1) })
					return ;
				}
				type = 'list'
				values = { list: list._id }
			}
			this.setState({ add_submitting: true, add_error: null })
			this.props.insertModule({
				name: cat_name,
				type: type,
				values: values,
				translations: [{ lang: this.props.lang_default, title: cat_name, values: { subtitle: subtitle } }],
				hidden: this.state.add_hidden
			})
			.then(ret => {
				if (!ret)
					return Promise.reject('insert_module')
				this.setState({ add_open: false, add_submitting: false, success: "« " + cat_name + " » est mis en avant sur l'accueil, en plus de sa place dans sa rubrique.", success_path: '/contenu/categorie/' + category._id })
			})
			.catch(err => {
				console.log(err)
				this.setState({ add_error: tools.default_error_msg("Impossible de mettre en avant cette catégorie", 2), add_submitting: false })
			})
			return ;
		}
		const name = this.state.add_name.trim()
		if (name.length === 0)
		{
			this.setState({ add_error: "Indiquez un nom" })
			return ;
		}
		if (name.length > this.name_length_max)
		{
			this.setState({ add_error: "Le nom ne doit pas dépasser " + this.name_length_max + " caractères" })
			return ;
		}
		if ((this.state.add_type === "group" || this.state.add_type === "list") && !this.state.add_icon)
		{
			this.setState({ add_error: "Choisissez une icône" })
			return ;
		}
		this.setState({ add_submitting: true, add_error: null })
		if (this.state.add_type === "list")
		{
			//liste directe : rubrique technique (trouvée ou créée) → catégorie type list → liste → module
			this._ensureTechnicalGroup()
			.then(group => {
				if (!group || group === false || !group._id)
					return Promise.reject('tech_group')
				return this.props.insertCategory({
					icon: this.state.add_icon,
					type: 'list',
					group: String(group._id),
					translations: [{ lang: this.props.lang_default, name: name }]
				})
			})
			.then(category => {
				if (category === 1)
					return Promise.reject('duplicate_name')
				if (!category || category === false || !category._id)
					return Promise.reject('insert_category')
				this._created_path = '/contenu/categorie/' + category._id
				return this.props.insertList({
					elements: [],
					category: String(category._id),
					translations: [{ lang: this.props.lang_default, name: name }]
				})
			})
			.then(list => {
				if (!list || list === false || !list._id)
					return Promise.reject('insert_list')
				return this.props.insertModule({
					name: name,
					type: 'list',
					values: { list: String(list._id) },
					translations: [{ lang: this.props.lang_default, title: name, values: { subtitle: this.state.add_subtitle.trim() } }],
					hidden: this.state.add_hidden
				})
			})
			.then(ret => {
				if (!ret)
					return Promise.reject('insert_module')
				this.setState({ add_open: false, add_submitting: false, success: "« " + name + " » est sur l'accueil. Ajoutez-y vos premiers éléments.", success_path: this._created_path })
			})
			.catch(err => {
				console.log(err)
				let msg = tools.default_error_msg("Impossible de créer la liste", 1)
				if (err === 'duplicate_name')
					msg = "Un autre contenu porte déjà ce nom. Choisissez un nom différent."
				else if (err === 'insert_list' || err === 'insert_module')
					msg = "La liste a été partiellement créée mais n'est pas sur l'accueil. Réessayez avec le même nom ou contactez-nous."
				this.setState({ add_error: msg, add_submitting: false })
			})
			return ;
		}
		if (this.state.add_type === "group")
		{
			//création chaînée : la rubrique puis sa présence sur l'accueil (même pattern que catégorie+page/liste)
			this.props.insertGroup({
				translations: [{ lang: this.props.lang_default, name: name }],
				icon: this.state.add_icon
			})
			.then(group => {
				if (!group || group === false || !group._id)
					return Promise.reject('insert_group')
				this._created_path = '/contenu/rubrique/' + group._id
				return this.props.insertModule({
					name: name,
					type: 'group',
					values: { group: group._id },
					translations: [{ lang: this.props.lang_default, title: name }],
					hidden: this.state.add_hidden
				})
			})
			.then(ret => {
				if (!ret)
					return Promise.reject('insert_module')
				this.setState({ add_open: false, add_submitting: false, success: "« " + name + " » est sur l'accueil. Créez-y vos premières catégories.", success_path: this._created_path })
			})
			.catch(err => {
				console.log(err)
				const msg = (err === 'insert_module') ?
					"La rubrique a été créée mais n'a pas pu être ajoutée à l'accueil. Réessayez depuis l'écran Page d'accueil historique."
					:
					tools.default_error_msg("Impossible de créer la rubrique", 1)
				this.setState({ add_error: msg, add_submitting: false })
			})
		}
		else if (this.state.add_type === "page")
		{
			//page seule (category null) : le serveur génère l'url depuis le nom ; category_name '' requis par la route
			this.props.insertPage({
				category: null,
				cover: null,
				sections: [],
				translations: [{ lang: this.props.lang_default, name: name, category_name: '' }]
			})
			.then(page => {
				if (!page || page === false || !page._id)
					return Promise.reject('insert_page')
				this._created_path = '/contenu/page/' + page._id
				return this.props.insertModule({
					name: name,
					type: 'page',
					values: { category: '', page: page._id },
					translations: [{ lang: this.props.lang_default, title: name, values: { subtitle: this.state.add_subtitle.trim() } }],
					hidden: this.state.add_hidden
				})
			})
			.then(ret => {
				if (!ret)
					return Promise.reject('insert_module')
				this.setState({ add_open: false, add_submitting: false, success: "« " + name + " » est sur l'accueil. Rédigez son contenu dès maintenant.", success_path: this._created_path })
			})
			.catch(err => {
				console.log(err)
				const msg = (err === 'insert_module') ?
					"La page a été créée mais n'a pas pu être ajoutée à l'accueil. Réessayez depuis l'écran Page d'accueil historique."
					:
					tools.default_error_msg("Impossible de créer la page", 1)
				this.setState({ add_error: msg, add_submitting: false })
			})
		}
	}

	// ---- Actions du menu ⋯ : retirer une mise en avant, supprimer un contenu ----

	// Type d'action destructive possible sur une ligne (null = aucune)
	_moduleAction = (module) => {
		if (module.type === "group")
			return 'delete_group'
		if (module.type === "page" && module.values && module.values.category)
			return 'unfeature'
		if (module.type === "page" && module.values && module.values.page)
			return 'delete_page'
		if (module.type === "list")
			return 'unfeature'
		return null
	}

	askConfirm = (module, kind) => {
		this.setState({ confirm: { module: module, kind: kind }, confirm_busy: false })
	}

	closeConfirm = () => {
		if (this.state.confirm_busy === true)
			return ;
		this.setState({ confirm: null })
	}

	confirmAction = () => {
		if (this.state.confirm === null || this.state.confirm_busy === true)
			return ;
		const module = this.state.confirm.module
		const kind = this.state.confirm.kind
		const title = tools.getTranslationValue(module.translations, this.props.lang_default, 'title') || module.name
		this.setState({ confirm_busy: true })
		let chain = null
		if (kind === 'unfeature')
			chain = this.props.deleteModule(module._id)
		else if (kind === 'delete_group')
		{
			chain = this.props.deleteModule(module._id)
			.then(ret => {
				if (!ret)
					return Promise.reject('delete_module')
				return this.props.deleteGroup(module.values.group)
			})
		}
		else if (kind === 'delete_page')
		{
			chain = this.props.deleteModule(module._id)
			.then(ret => {
				if (!ret)
					return Promise.reject('delete_module')
				return this.props.deletePage(module.values.page)
			})
		}
		chain
		.then(ret => {
			if (!ret)
				return Promise.reject('delete_content')
			const msg = (kind === 'unfeature') ?
				"La mise en avant de « " + title + " » a été retirée. Le contenu reste dans sa rubrique."
				:
				"« " + title + " » a été supprimé."
			this.setState({ confirm: null, confirm_busy: false, success: msg, error: null })
		})
		.catch(err => {
			console.log(err)
			this.setState({ confirm: null, confirm_busy: false, error: tools.default_error_msg("Impossible de terminer la suppression", 1) })
		})
	}

	// Destination du clic sur une ligne : la rubrique, la catégorie ou la page seule pointée (null = pas de drill-down)
	_modulePath = (module) => {
		if (module.type === "group" && module.values && module.values.group)
			return "/contenu/rubrique/" + module.values.group
		if (module.type === "page" && module.values)
		{
			if (module.values.category)
				return "/contenu/categorie/" + module.values.category
			if (module.values.page)
				return "/contenu/page/" + module.values.page
		}
		if (module.type === "list" && module.values && module.values.list && this.state.lists)
		{
			for (let i = 0; i < this.state.lists.length; i++)
			{
				if (this.state.lists[i]._id === module.values.list)
					return "/contenu/categorie/" + this.state.lists[i].category
			}
		}
		return null
	}

	// Pastilles d'état des langues activées : verte = traduite, orange = manquante
	_langChips = (translations, fields) => {
		if (!this.props.langs)
			return null
		return (
			<span className="inline-flex flex-wrap">
				{this.props.langs.map((lang) => {
					const missing = (tools.getMissingLangs(translations, [lang], fields).length > 0)
					return (
						<span
							key={lang}
							title={(missing) ? "Traduction manquante" : "Traduite"}
							className={"text-xs font-bold uppercase rounded-md px-2 py-1 mr-1 " + ((missing) ? "bg-yellow-100 text-yellow-700" : "bg-green-50 text-green-700")}
						>{lang}{(missing) ? ' !' : ''}</span>
					)
				})}
			</span>
		)
	}

	// Format vu par le vacancier sur la home : Tuiles (rubrique), Carte (page/liste), Animations
	_moduleFormat = (module) => {
		if (module.type === "group")
			return { glyph: '▦', label: 'Tuiles', classes: 'bg-indigo-50 text-indigo-700', dot: 'bg-indigo-500', tile: 'bg-indigo-50 text-indigo-500' }
		else if (module.type === "animation")
			return { glyph: '✦', label: 'Animations', classes: 'bg-yellow-50 text-yellow-700', dot: 'bg-yellow-500', tile: 'bg-yellow-50 text-yellow-600' }
		else
			return { glyph: '▭', label: 'Carte', classes: 'bg-green-50 text-green-700', dot: 'bg-green-500', tile: 'bg-green-50 text-green-600' }
	}

	// Ligne de description : le détail technique du contenu pointé
	_moduleMeta = (module) => {
		if (module.type === "group")
		{
			let count = 0
			for (let i = 0; i < this.state.categories.length; i++)
			{
				if (this.state.categories[i].group === module.values.group)
					count++
			}
			return "Rubrique · " + count + ((count > 1) ? " catégories" : " catégorie")
		}
		if (module.type === "animation")
			return "Unique · programme géré dans l'onglet Animations"
		const translation = tools.getTranslation(module.translations, this.props.lang_default)
		const subtitle = (translation && translation.values && translation.values.subtitle) ? translation.values.subtitle : null
		let meta = (module.type === "list") ? "Liste" : "Page"
		if (subtitle)
			meta += " · sous-titre : « " + subtitle + " »"
		return meta
	}

	// Icône de la rubrique pointée (les autres types n'ont pas d'icône propre)
	_moduleIcon = (module) => {
		if (module.type !== "group")
			return null
		const group = this.state.groups.find(g => g._id === module.values.group)
		if (!group)
			return null
		return tools.getIconPreview(this.state.icons, group.icon, 'lineal', 'blank')
	}

	render() {
		const permissions = this.props.user.permissions
		if (!permissions || !permissions.rubrics || permissions.rubrics === 0)
			return (<Redirect to="/" />)
		if (this.state.modules === null)
		{
			if (this.state.error !== null)
				return (<p className="error center">{this.state.error}</p>)
			return (
				<div className="loader">
					<Loader />
				</div>
			)
		}
		const modules = this.state.modules
		let masked_count = 0
		let incomplete_count = 0
		for (let i = 0; i < modules.length; i++)
		{
			if (modules[i].hidden === true)
				masked_count++
			if (tools.getMissingLangs(modules[i].translations, this.props.langs, ['title']).length > 0)
				incomplete_count++
		}
		return (
			<div className="wrapper-content">
				<div className="flex flex-wrap items-start">
				<div className="flex-1" style={{ minWidth: '340px' }}>
				<div className="bg-white rounded-2xl shadow border border-gray-200 px-6 py-5 flex justify-between items-center flex-wrap mb-5">
					<div className="mr-6">
						<h2 className="text-2xl font-bold tracking-tight text-gray-900 mb-0">Contenu de mon app</h2>
						<p className="mt-1 text-sm text-gray-500 mb-0">Ce que vous voyez ici est ce que vos vacanciers voient sur l'app, dans le même ordre.</p>
					</div>
					<div className="flex items-center">
						<div className="text-center px-5 border-r border-gray-100">
							<p className="text-2xl font-bold text-gray-900 mb-0 tabular-nums">{modules.length}</p>
							<p className="text-xs uppercase tracking-wide text-gray-400 font-semibold mb-0">élément{(modules.length > 1) ? 's' : ''}</p>
						</div>
						<div className="text-center px-5 border-r border-gray-100">
							<p className="text-2xl font-bold text-gray-400 mb-0 tabular-nums">{masked_count}</p>
							<p className="text-xs uppercase tracking-wide text-gray-400 font-semibold mb-0">masqué{(masked_count > 1) ? 's' : ''}</p>
						</div>
						<div className="text-center px-5 mr-4">
							<p className={"text-2xl font-bold mb-0 tabular-nums " + ((incomplete_count > 0) ? "text-yellow-600" : "text-gray-400")}>{incomplete_count}</p>
							<p className={"text-xs uppercase tracking-wide font-semibold mb-0 " + ((incomplete_count > 0) ? "text-yellow-600" : "text-gray-400")}>{(incomplete_count > 0) ? "⚠ " : ""}trad. incomplète{(incomplete_count > 1) ? 's' : ''}</p>
						</div>
						<button
							type="button"
							onClick={this.openAdd}
							className="text-sm font-semibold text-white rounded-lg px-4 py-2"
							style={{ backgroundImage: 'none', backgroundColor: '#4F46E5' }}
						>+ Ajouter à l'accueil</button>
					</div>
				</div>
				{this.state.success !== null &&
					<div className="flex items-center justify-between bg-green-50 border border-green-200 text-green-800 text-sm font-medium rounded-xl px-4 py-3 mb-4">
						<span>✓ {this.state.success}</span>
						<button
							type="button"
							onClick={() => this.setState({ success: null })}
							aria-label="Fermer"
							className="text-green-700 font-bold ml-4"
							style={{ backgroundImage: 'none', backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}
						>✕</button>
					</div>
				}
				{this.state.error !== null &&
					<p className="error center">{this.state.error}</p>
				}
				{(!modules || !modules.length) &&
					<EmptyFolder emptyFolderSubtitle="Il n'y a pas encore de contenu sur votre application." />
				}
				<div className="bg-white rounded-2xl shadow border border-gray-200 divide-y divide-gray-100">
					<div className="hidden md:flex items-center px-5 py-2 bg-gray-50 rounded-t-2xl text-xs uppercase tracking-wide text-gray-400 font-semibold">
						<span className="w-5 mr-4 text-right">N°</span>
						<span className="w-10 mr-4"></span>
						<span className="flex-1">Élément</span>
						<span className="w-32 ml-4">Format visuel</span>
						<span className="w-48 ml-4">État des langues</span>
						<span className="w-56 ml-4 text-right">Actions</span>
					</div>
					{modules.map((module, index) => {
						const format = this._moduleFormat(module)
						const meta = this._moduleMeta(module)
						const icon = this._moduleIcon(module)
						const title = tools.getTranslationValue(module.translations, this.props.lang_default, 'title') || module.name
						const hidden = (module.hidden === true)
						const tileStyle = (icon && this.state.theme && this.state.theme.color1) ? { backgroundColor: '#' + this.state.theme.color1 } : {}
						const rowStyle = (hidden) ? { background: 'repeating-linear-gradient(45deg, #FAFAFB, #FAFAFB 8px, #F5F5F7 8px, #F5F5F7 16px)' } : {}
						const path = this._modulePath(module)
						return (
							<div
								key={module._id}
								className={"flex items-center px-5 py-4 hover:bg-gray-50 transition-colors group " + ((path) ? "cursor-pointer" : "")}
								style={rowStyle}
								onClick={(path) ? () => this.props.history.push(path) : undefined}
								title={(module.type === "animation") ? "Le programme se gère dans l'onglet Animations" : undefined}
							>
								<span className="w-5 text-right text-sm font-semibold text-gray-400 tabular-nums flex-shrink-0 mr-4" aria-label={"Position " + (index + 1)}>{index + 1}</span>
								<div className={"w-10 h-10 rounded-xl flex-shrink-0 flex items-center justify-center " + ((icon) ? "" : format.tile) + ((hidden) ? " opacity-40" : "")} style={tileStyle}>
									{(icon) ? <img src={icon} className="w-6 h-6" alt="" /> : <span className="text-base" aria-hidden="true">{format.glyph}</span>}
								</div>
								<div className="flex-1 min-w-0 ml-4">
									<p className={"text-base font-bold truncate mb-0 " + ((hidden) ? "text-gray-400" : "text-gray-900")}>
										{title}
										{hidden &&
											<span className="ml-2 align-middle text-xs font-medium text-gray-500 bg-white border border-dashed border-gray-300 rounded-full px-2 py-0.5">Masquée</span>
										}
									</p>
									<p className={"text-xs truncate mb-0 mt-0.5 " + ((hidden) ? "text-gray-300" : "text-gray-400")}>{meta}</p>
								</div>
								<span className="w-32 ml-4 flex-shrink-0">
									<span className={"inline-flex items-center text-xs font-semibold uppercase tracking-wide rounded-full px-3 py-1 " + format.classes + ((hidden) ? " opacity-50" : "")}>
										<span className={"w-1.5 h-1.5 rounded-full mr-1.5 " + format.dot} aria-hidden="true"></span>
										{format.label}
									</span>
								</span>
								<span className="w-48 ml-4 flex-shrink-0">
									{this._langChips(module.translations, ['title'])}
								</span>
								<div className="w-56 ml-4 flex items-center justify-end flex-shrink-0">
									<button
										type="button"
										onClick={(e) => { e.stopPropagation(); this.toggleHidden(module) }}
										title={(hidden) ? "Rendre visible sur l'app" : "Masquer sur l'app (garde sa place et son contenu)"}
										className="text-xs font-semibold text-gray-600 bg-white border border-gray-300 rounded-lg px-3 py-1.5 mr-2 hover:border-indigo-400"
										style={{ backgroundImage: 'none', backgroundColor: '#fff' }}
									>{(hidden) ? "Afficher" : "Masquer"}</button>
									<div className="flex flex-col">
										<button
											type="button"
											onClick={(e) => { e.stopPropagation(); this.moveModule(index, -1) }}
											disabled={index === 0}
											aria-label="Monter"
											className={"p-0.5 rounded " + ((index === 0) ? "text-gray-200 cursor-default" : "text-gray-400 hover:text-gray-700 hover:bg-gray-100")}
											style={{ backgroundImage: 'none', backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}
										><ChevronUpIcon className="h-4 w-4" /></button>
										<button
											type="button"
											onClick={(e) => { e.stopPropagation(); this.moveModule(index, 1) }}
											disabled={index === modules.length - 1}
											aria-label="Descendre"
											className={"p-0.5 rounded " + ((index === modules.length - 1) ? "text-gray-200 cursor-default" : "text-gray-400 hover:text-gray-700 hover:bg-gray-100")}
											style={{ backgroundImage: 'none', backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}
										><ChevronDownIcon className="h-4 w-4" /></button>
									</div>
									{(path) ?
										<span className="text-sm font-bold text-gray-600 group-hover:text-indigo-600 ml-2 whitespace-nowrap">Ouvrir ›</span>
										:
										<span className="text-sm font-bold text-transparent ml-2 whitespace-nowrap" aria-hidden="true">Ouvrir ›</span>
									}
									{(this._moduleAction(module) !== null) ?
										<span onClick={(e) => e.stopPropagation()}>
											<Menu as="div" className="relative ml-2">
												<Menu.Button
													className="w-8 h-8 rounded-lg border border-gray-200 text-gray-500 font-bold text-sm"
													style={{ backgroundImage: 'none', backgroundColor: '#fff' }}
													aria-label="Plus d'actions"
												>⋯</Menu.Button>
												<Menu.Items className="absolute right-0 mt-1 w-56 bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-10 py-1">
													{(this._moduleAction(module) === 'unfeature') &&
														<Menu.Item>
															{({ active }) => (
																<button
																	type="button"
																	onClick={() => this.askConfirm(module, 'unfeature')}
																	className={"block w-full text-left px-4 py-2 text-sm text-gray-700 " + ((active) ? "bg-gray-100 focus:bg-gray-100" : "focus:bg-white")}
																	style={{ backgroundImage: 'none', border: 'none', boxShadow: 'none' }}
																>Retirer la mise en avant</button>
															)}
														</Menu.Item>
													}
													{(this._moduleAction(module) === 'delete_group') &&
														<Menu.Item>
															{({ active }) => (
																<button
																	type="button"
																	onClick={() => this.askConfirm(module, 'delete_group')}
																	className={"block w-full text-left px-4 py-2 text-sm text-red-600 " + ((active) ? "bg-red-50 focus:bg-red-50" : "focus:bg-white")}
																	style={{ backgroundImage: 'none', border: 'none', boxShadow: 'none' }}
																>Supprimer la rubrique…</button>
															)}
														</Menu.Item>
													}
													{(this._moduleAction(module) === 'delete_page') &&
														<Menu.Item>
															{({ active }) => (
																<button
																	type="button"
																	onClick={() => this.askConfirm(module, 'delete_page')}
																	className={"block w-full text-left px-4 py-2 text-sm text-red-600 " + ((active) ? "bg-red-50 focus:bg-red-50" : "focus:bg-white")}
																	style={{ backgroundImage: 'none', border: 'none', boxShadow: 'none' }}
																>Supprimer la page…</button>
															)}
														</Menu.Item>
													}
												</Menu.Items>
											</Menu>
										</span>
										:
										<span className="w-8 h-8 ml-2" aria-hidden="true"></span>
									}
								</div>
							</div>
						)
					})}
				</div>
				<p className="mt-3 text-xs text-gray-400">Écran en construction : l'ordre, le drill-down et l'ajout (rubrique, page) sont actifs ; mise en avant, listes directes et masquage arrivent dans les prochains lots. Les écrans Rubriques et Page d'accueil restent accessibles.</p>
				</div>
				<div className="flex-shrink-0 ml-8 sticky top-4" style={{ width: '300px' }}>
					<p className="text-xs font-bold uppercase tracking-wide text-green-700 mb-2 flex items-center">
						<span className="w-1.5 h-1.5 rounded-full bg-green-500 mr-1.5" aria-hidden="true"></span>
						Aperçu en direct (vacancier)
					</p>
					<div className="rounded-3xl bg-gray-900 p-2 shadow-xl">
						<div className="w-10 h-1 rounded-full bg-gray-700 mx-auto mb-1.5" aria-hidden="true"></div>
						<div className="rounded-2xl bg-white" style={{ height: '600px', overflow: 'hidden' }}>
							{/* rendu à largeur native 375px puis réduit — même technique que l'aperçu des pages */}
							<div style={{ width: '375px', height: '792px', transform: 'scale(0.757)', transformOrigin: 'top left', overflowY: 'auto' }}>
								<RenderHome
									modules={modules}
									categories={this.state.categories}
									icons={this.state.icons}
									theme={this.state.theme}
									lang={this.props.lang_default}
								/>
							</div>
						</div>
					</div>
					<p className="text-xs text-gray-400 mt-2 mb-0">Ordre, visibilité et titres en temps réel. Les photos des cartes sont figurées par la couleur du thème.</p>
				</div>
				</div>
				{this.state.add_open === true &&
					<div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto" role="dialog" aria-modal="true" aria-label="Ajouter à l'accueil">
						<div className="fixed inset-0 bg-black bg-opacity-40" onClick={this.closeAdd}></div>
						<div className="relative bg-white rounded-2xl shadow-xl w-full mx-4 my-16 px-6 py-6" style={{ maxWidth: '540px' }}>
							<div className="flex items-start justify-between mb-4">
								<div>
									<h3 className="text-lg font-bold text-gray-900 mb-0">
										{(this.state.add_type === null) ? "Que voulez-vous ajouter à l'accueil ?" : ((this.state.add_type === "group") ? "Nouvelle rubrique" : ((this.state.add_type === "existing") ? "Mettre en avant un contenu" : ((this.state.add_type === "list") ? "Nouvelle liste" : "Nouvelle page")))}
									</h3>
									{this.state.add_type !== null &&
										<button
											type="button"
											onClick={() => this.chooseAddType(null)}
											className="text-xs font-semibold text-indigo-600 mt-1"
											style={{ backgroundImage: 'none', backgroundColor: 'transparent', border: 'none', boxShadow: 'none', padding: 0 }}
										>‹ Changer de type</button>
									}
								</div>
								<button
									type="button"
									onClick={this.closeAdd}
									aria-label="Fermer"
									className="text-gray-400 hover:text-gray-700 font-bold text-lg leading-none"
									style={{ backgroundImage: 'none', backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}
								>✕</button>
							</div>
							{(this.state.add_type === null) ?
								<div>
									<button
										type="button"
										onClick={() => this.chooseAddType('group')}
										className="w-full flex items-center text-left border border-gray-200 hover:border-indigo-400 rounded-xl px-4 py-3 mb-2"
										style={{ backgroundImage: 'none', backgroundColor: '#fff', boxShadow: 'none' }}
									>
										<span className="w-10 h-10 rounded-xl bg-indigo-50 text-indigo-500 flex items-center justify-center text-lg flex-shrink-0 mr-3" aria-hidden="true">▦</span>
										<span className="flex-1 min-w-0">
											<span className="block text-sm font-bold text-gray-900">Une rubrique <span className="text-xs font-semibold uppercase text-indigo-600 ml-1">▦ Tuiles</span></span>
											<span className="block text-xs text-gray-400">Un grand thème qui regroupe plusieurs catégories. Ex : « Nos équipements »</span>
										</span>
									</button>
									<button
										type="button"
										onClick={() => this.chooseAddType('page')}
										className="w-full flex items-center text-left border border-gray-200 hover:border-indigo-400 rounded-xl px-4 py-3 mb-2"
										style={{ backgroundImage: 'none', backgroundColor: '#fff', boxShadow: 'none' }}
									>
										<span className="w-10 h-10 rounded-xl bg-green-50 text-green-600 flex items-center justify-center text-lg flex-shrink-0 mr-3" aria-hidden="true">▭</span>
										<span className="flex-1 min-w-0">
											<span className="block text-sm font-bold text-gray-900">Une page <span className="text-xs font-semibold uppercase text-green-700 ml-1">▭ Carte</span></span>
											<span className="block text-xs text-gray-400">Une page seule, mise en avant directement sur l'accueil. Ex : « Le marché nocturne »</span>
										</span>
									</button>
									<button
										type="button"
										onClick={() => this.chooseAddType('list')}
										className="w-full flex items-center text-left border border-gray-200 hover:border-indigo-400 rounded-xl px-4 py-3 mb-2"
										style={{ backgroundImage: 'none', backgroundColor: '#fff', boxShadow: 'none' }}
									>
										<span className="w-10 h-10 rounded-xl bg-purple-50 text-purple-500 flex items-center justify-center text-lg flex-shrink-0 mr-3" aria-hidden="true">▭</span>
										<span className="flex-1 min-w-0">
											<span className="block text-sm font-bold text-gray-900">Une liste <span className="text-xs font-semibold uppercase text-green-700 ml-1">▭ Carte</span></span>
											<span className="block text-xs text-gray-400">Une collection d'éléments ou de sous-catégories. Ex : « Où manger dans le coin »</span>
										</span>
									</button>
									<p className="text-center text-xs uppercase tracking-wide text-gray-300 font-semibold my-3">ou</p>
									<button
										type="button"
										onClick={() => this.chooseAddType('existing')}
										className="w-full flex items-center text-left border border-gray-200 hover:border-indigo-400 rounded-xl px-4 py-3"
										style={{ backgroundImage: 'none', backgroundColor: '#fff', boxShadow: 'none' }}
									>
										<span className="w-10 h-10 rounded-xl bg-yellow-50 text-yellow-600 flex items-center justify-center text-lg flex-shrink-0 mr-3" aria-hidden="true">★</span>
										<span className="flex-1 min-w-0">
											<span className="block text-sm font-bold text-gray-900">Mettre en avant un contenu existant <span className="text-xs font-semibold uppercase text-green-700 ml-1">▭ Carte</span></span>
											<span className="block text-xs text-gray-400">Une catégorie déjà dans une rubrique, aussi en grande carte sur l'accueil.</span>
										</span>
									</button>
								</div>
								:
								<form onSubmit={this.submitAdd}>
									{(this.state.add_type === "existing") ?
										<div className="mb-4">
											<label className="block mb-4">
												<span className="block text-xs font-semibold text-gray-600 mb-1">Catégorie à mettre en avant</span>
												<select className="browser-default select-modern w-full" value={this.state.add_category} onChange={this.handleAddCategory}>
													<option value="">-- Sélectionner une catégorie --</option>
													{this._availableCategories().map((category) => {
														let group_name = ""
														for (let i = 0; i < this.state.groups.length; i++)
														{
															if (this.state.groups[i]._id === category.group)
															{
																group_name = tools.getTranslationValue(this.state.groups[i].translations, this.props.lang_default, 'name')
																break
															}
														}
														const cat_name = tools.getTranslationValue(category.translations, this.props.lang_default, 'name')
														return (<option key={category._id} value={category._id}>{(group_name) ? group_name + " › " : ""}{cat_name}</option>)
													})}
												</select>
												<span className="block text-xs text-green-700 mt-1">✓ La carte portera le nom de la catégorie, et le contenu reste aussi dans sa rubrique.</span>
											</label>
											<label className="block">
												<span className="block text-xs font-semibold text-gray-600 mb-1">Sous-titre de la carte (optionnel) — ex. « Tous les mardis dès 18h »</span>
												<input className="input-modern w-full" type="text" value={this.state.add_subtitle} onChange={this.handleAddSubtitle} />
											</label>
										</div>
										:
										<div className="mb-4">
											<label className="block">
												<span className="block text-xs font-semibold text-gray-600 mb-1">{(this.state.add_type === "group") ? "Nom de la rubrique" : ((this.state.add_type === "list") ? "Nom de la liste" : "Nom de la page")}</span>
												<input className="input-modern w-full" type="text" value={this.state.add_name} onChange={this.handleAddName} autoFocus />
												<span className="block text-xs text-green-700 mt-1">✓ Ce nom sera aussi le titre affiché sur l'accueil.</span>
											</label>
											{(this.state.add_type === "page" || this.state.add_type === "list") &&
												<label className="block mt-3">
													<span className="block text-xs font-semibold text-gray-600 mb-1">Sous-titre de la carte (optionnel) — ex. « Tous les mardis dès 18h »</span>
													<input className="input-modern w-full" type="text" value={this.state.add_subtitle} onChange={this.handleAddSubtitle} />
												</label>
											}
										</div>
									}
									{(this.state.add_type === "group" || this.state.add_type === "list") &&
										<div className="mb-4">
											<p className="text-xs font-semibold text-gray-600 mb-1">Icône :</p>
											<div className="flex items-center">
												{this.state.add_prev &&
													<span className="w-9 h-9 rounded-lg flex items-center justify-center mr-3 flex-shrink-0" style={(this.state.theme && this.state.theme.color1) ? { backgroundColor: '#' + this.state.theme.color1 } : { backgroundColor: '#9CA3AF' }}>
														<img src={this.state.add_prev} className="w-6 h-6" alt="Icône choisie" />
													</span>
												}
												<IconPicker type="lineal" theme="blank" icons={this.state.icons} onChange={this.handleAddIcon} />
											</div>
										</div>
									}
									<p className="text-xs font-semibold text-gray-600 mb-1">Visibilité :</p>
									<label className="flex items-start mb-2 cursor-pointer">
										<input className="radio-modern mt-0.5" type="radio" name="add_visibility" checked={this.state.add_hidden === false} onChange={() => this.setState({ add_hidden: false })} />
										<span className="ml-2">
											<span className="block text-sm font-semibold text-gray-900">Visible sur l'accueil</span>
											<span className="block text-xs text-gray-400">Vos vacanciers voient ce contenu dès maintenant.</span>
										</span>
									</label>
									<label className="flex items-start cursor-pointer">
										<input className="radio-modern mt-0.5" type="radio" name="add_visibility" checked={this.state.add_hidden === true} onChange={() => this.setState({ add_hidden: true })} />
										<span className="ml-2">
											<span className="block text-sm font-semibold text-gray-900">Masquée pour l'instant</span>
											<span className="block text-xs text-gray-400">Préparez le contenu tranquillement, invisible sur l'app. Un clic sur « Afficher » quand c'est prêt.</span>
										</span>
									</label>
									{this.state.add_error &&
										<p className="text-xs text-red-600 font-medium mt-3 mb-0">{this.state.add_error}</p>
									}
									{(this.state.add_submitting === true) ?
										<div className="center mt-4">
											<Loader />
										</div>
										:
										<div className="flex justify-end pt-4 mt-4 border-t border-gray-100">
											<button
												type="button"
												onClick={this.closeAdd}
												className="text-sm font-semibold text-gray-600 bg-white border border-gray-300 rounded-lg px-4 py-2 mr-2"
												style={{ backgroundImage: 'none', backgroundColor: '#fff' }}
											>Annuler</button>
											<button
												type="submit"
												className="text-sm font-semibold text-white rounded-lg px-5 py-2"
												style={{ backgroundImage: 'none', backgroundColor: '#4F46E5' }}
											>{(this.state.add_type === "group") ? "Créer la rubrique" : ((this.state.add_type === "existing") ? "Mettre en avant" : ((this.state.add_type === "list") ? "Créer la liste" : "Créer la page"))}</button>
										</div>
									}
								</form>
							}
						</div>
					</div>
				}
				{this.state.confirm !== null &&
					<div className="fixed inset-0 z-50 flex items-center justify-center" role="dialog" aria-modal="true" aria-label="Confirmation">
						<div className="fixed inset-0 bg-black bg-opacity-40" onClick={this.closeConfirm}></div>
						<div className="relative bg-white rounded-2xl shadow-xl w-full mx-4 px-6 py-6" style={{ maxWidth: '440px' }}>
							{(this.state.confirm.kind === 'unfeature') ?
								<div>
									<h3 className="text-base font-bold text-gray-900 mb-1">Retirer la mise en avant ?</h3>
									<p className="text-sm text-gray-500 mb-0">La grande carte disparaît de l'accueil. Le contenu reste intact dans sa rubrique, et vous pourrez le remettre en avant à tout moment.</p>
								</div>
								:
								<div>
									<h3 className="text-base font-bold text-red-700 mb-1">{(this.state.confirm.kind === 'delete_group') ? "Supprimer cette rubrique ?" : "Supprimer cette page ?"}</h3>
									<p className="text-sm text-gray-500 mb-0">{(this.state.confirm.kind === 'delete_group') ? "La rubrique et tout le contenu qui s'y trouve (catégories, pages, listes) seront supprimés de l'app. Cette action est irréversible." : "La page et tout son contenu seront supprimés de l'app. Cette action est irréversible."}</p>
								</div>
							}
							{(this.state.confirm_busy === true) ?
								<div className="center mt-4">
									<Loader />
								</div>
								:
								<div className="flex justify-end pt-4 mt-4 border-t border-gray-100">
									<button
										type="button"
										onClick={this.closeConfirm}
										className="text-sm font-semibold text-gray-600 bg-white border border-gray-300 rounded-lg px-4 py-2 mr-2"
										style={{ backgroundImage: 'none', backgroundColor: '#fff' }}
									>Annuler</button>
									<button
										type="button"
										onClick={this.confirmAction}
										className="text-sm font-semibold text-white rounded-lg px-5 py-2"
										style={{ backgroundImage: 'none', backgroundColor: (this.state.confirm.kind === 'unfeature') ? '#4F46E5' : '#DC2626' }}
									>{(this.state.confirm.kind === 'unfeature') ? "Retirer" : "Supprimer définitivement"}</button>
								</div>
							}
						</div>
					</div>
				}
			</div>
		)
	}
}

export default Contenu
